import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logoDark from "../../../../assets/images/logo-dark.webp";
import {
    getVendorLogoutRequest,
    getVendorLogoutSuccess,
} from "../../../../redux/vendor/auth/logout/action";
import { VENDOR_NAV_ITEMS } from "./navItems";
import { VendorMenuLockSvg, VendorMenuLogoutSvg } from "../../../CommonSvg";
import { vendorLogoUrl } from "../../../../utils/generalUtils";
import NotificationBell from "../../NotificationBell";
import { vendorHasRole } from "../../../../utils/authUtils";

const getInitials = (name) => {
    if (!name) return "V";
    return name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join("");
};

const VendorHeader = (props) => {
    const { logoutVendor, clearLogoutState, logoutData } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const barRef = useRef(null);

    const contactName = localStorage.getItem("vendorContactName") || "Vendor User";
    const email = localStorage.getItem("vendorEmail") || "";
    const initials = getInitials(contactName);

    const vendorLogo = vendorLogoUrl(localStorage.getItem("vendorLogo"));
    const [logoFailed, setLogoFailed] = useState(false);
    const showVendorLogo = Boolean(vendorLogo) && !logoFailed;

    useEffect(() => {
        const close = () => setUserMenuOpen(false);
        document.addEventListener("click", close);
        return () => document.removeEventListener("click", close);
    }, []);

    useEffect(() => {
        setUserMenuOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        const bar = barRef.current;
        const shell = bar?.closest(".vendor-portal");
        if (!bar || !shell) return undefined;

        const sync = () => {
            shell.style.setProperty("--vp-hdr-h", `${bar.offsetHeight}px`);
        };
        sync();

        if (typeof ResizeObserver === "undefined") {
            window.addEventListener("resize", sync);
            return () => window.removeEventListener("resize", sync);
        }
        const observer = new ResizeObserver(sync);
        observer.observe(bar);
        return () => observer.disconnect();
    }, []);

    const toggleUserMenu = (e) => {
        e.stopPropagation();
        setUserMenuOpen((prev) => !prev);
    };

    useEffect(() => {
        if (logoutData?.status === true) {
            clearLogoutState();
            navigate("/vendor/login");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logoutData?.status]);

    const handleLogout = () => {
        logoutVendor();
    };

    const navItems = VENDOR_NAV_ITEMS.filter(
        ({ roleId }) => !roleId || vendorHasRole(roleId)
    );

    return (
        <div className="vp-hdr-wrap">
            <div className="vp-hdr" ref={barRef}>
                <img
                    className="vp-logo-img"
                    src={showVendorLogo ? vendorLogo : logoDark}
                    alt={showVendorLogo ? contactName : "HRA — The Power of Collective"}
                    onError={() => setLogoFailed(true)}
                />
                <div className="spacer" />

                <nav className="vp-nav">
                    {navItems.map(({ to, label, Icon }) => (
                        <NavLink key={to} to={to} className={({ isActive }) => (isActive ? "active" : "")}>
                            <Icon />
                            <span className="lbl">{label}</span>
                        </NavLink>
                    ))}
                </nav>

                <NotificationBell className="vp-bell" />

                <div className="vp-me-wrap">
                    <div className="vp-me" onClick={toggleUserMenu}>
                        {initials}
                    </div>
                    <div
                        className={`vp-me-menu${userMenuOpen ? " open" : ""}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="vp-um-head">
                            <span className="vp-me">{initials}</span>
                            <div>
                                <b>{contactName}</b>
                                <span className="vp-um-mail">{email}</span>
                            </div>
                        </div>

                        <nav className="vp-um-nav">
                            {navItems.map(({ to, label, Icon }) => (
                                <NavLink
                                    key={to}
                                    to={to}
                                    className={({ isActive }) => (isActive ? "active" : "")}
                                >
                                    <Icon />
                                    {label}
                                </NavLink>
                            ))}
                        </nav>

                        <NavLink to="/vendor/change-password" className="vp-um-item alt">
                            <VendorMenuLockSvg />
                            Change password
                        </NavLink>

                        <button type="button" className="vp-um-item" onClick={handleLogout}>
                            <VendorMenuLogoutSvg />
                            Logout
                        </button>
                    </div>
                </div>

            </div>

        </div>
    );
};

const mapStateToProps = ({ VendorLogout }) => {
    return { logoutData: VendorLogout?.logoutUser };
};

const mapDispatchToProps = (dispatch) => {
    return {
        logoutVendor: () => dispatch(getVendorLogoutRequest()),
        clearLogoutState: () => dispatch(getVendorLogoutSuccess(null)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VendorHeader);
